import cn from "classnames";
import { Input } from "antd";
import { ReactNode, useEffect, useState } from "react";
import styles from "./EditableValueField.module.scss";

export interface EditableValueFieldProps {
  readonly id?: string;
  readonly label: ReactNode;
  readonly value: string;
  onChange(value: string): void;
  readonly pattern?: RegExp;
  readonly addonAfter?: ReactNode;
  readonly className?: string;
  readonly isError?: boolean;
  readonly outlined?: boolean;
  readonly disabled?: boolean;
  readonly readOnly?: boolean;
  readonly dataBage?: string;
  readonly autoComplete?: string;
}

export default function EditableValueField({
  id,
  label,
  value,
  onChange,
  pattern,
  addonAfter,
  className,
  isError,
  outlined,
  disabled,
  readOnly,
  dataBage,
  autoComplete,
}: EditableValueFieldProps) {
  const [inputValue, setInputValue] = useState(value);

  useEffect(() => {
    setInputValue(value);
  }, [value]);

  return (
    <div className={cn(styles.field, className, { [styles.error]: isError })}>
      <label className={styles.label} htmlFor={id}>{label}</label>
      <Input
        id={id}
        size='small'
        value={inputValue}
        disabled={disabled}
        readOnly={readOnly}
        status={isError ? "error" : ""}
        data-bage={dataBage}
        autoComplete={autoComplete}
        onChange={(e) => {
          if (pattern && !pattern.test(e.target.value)) return;
          setInputValue(e.target.value);
          onChange(e.target.value);
        }}
        addonAfter={addonAfter}
        variant={outlined ? "outlined" : "borderless"}
      />
    </div>
  );
}
